import Input from "./Input";
// react-bootstrap components
import { Button, Card, Container, Row, Col, Spinner } from "react-bootstrap";

import DropdownInput from "./DropdownInput";


const AdminUserRegistrationForm = (props) => {
  const userRoles = [
    {
      label: "Essilor Admin",
      value: "ESSILORADMIN",
    },
    {
      label: "Mediator",
      value: "MEDIATOR",
    },
    {
      label: "Doctor",
      value: "DOCTOR",
    },
  ];

  return (
    <Container fluid className="mt-20">
      <Row>
        <Col lg="12">
          <Card className="card-stats">
            <Card.Header>
              <Card.Title as="h1">Admin User Registration</Card.Title>
              <hr />
            </Card.Header>
            <Card.Body>
              <form
                onSubmit={props.handleSubmit(
                  props.handleSubmitRegistration,
                  props.handleSubmitError
                )}
              >
                <div className="container">
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div className="row mt-10">
                        <Input
                          required={true}
                          register={props.register("FirstName")}
                          label={"FirstName"}
                        />
                        {props.errors.FirstName && (
                          <span className={"error-validation"}>
                            This field is required
                          </span>
                        )}
                      </div>
                      <div className="row mt-10">
                        <Input
                          required={true}
                          register={props.register("LastName")}
                          label={"Last Name"}
                        />
                        {props.errors.LastName && (
                          <span className={"error-validation"}>
                            This field is required
                          </span>
                        )}
                      </div>
                      <div className="row mt-10">
                        <DropdownInput
                          items={userRoles}
                          required={true}
                          register={props.register("UserRole")}
                          label={"User Role"}
                        />
                        {props.errors.UserRole && (
                          <span className={"error-validation"}>
                            This field is required
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div className="row mt-10">
                        <Input
                          required={true}
                          register={props.register("Email")}
                          label={"Email Address"}
                        />
                        {props.errors.Email?.message && (
                          <span className={"error-validation"}>
                            {props.errors.Email?.message}
                          </span>
                        )}
                      </div>
                      <div className="row mt-10">
                        <Input
                          required={true}
                          register={props.register("PracticeName")}
                          label={"Practice Name"}
                        />
                        {props.errors.PracticeName && (
                          <span className={"error-validation"}>
                            This field is required
                          </span>
                        )}
                      </div>
                      <div className="row mt-10">
                        <Input
                          required={true}
                          register={props.register("AreaOfExpertise")}
                          label={"Area of Expertise"}
                        />
                        {props.errors.AreaOfExpertise && (
                          <span className={"error-validation"}>
                            This field is required
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-6 mt-10">
                      <Input
                        type={"password"}
                        required={true}
                        register={props.register("Password")}
                        label={"Password"}
                      />
                      {props.errors.Password?.message && (
                        <span className={"error-validation"}>
                          {props.errors.Password?.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row mb-20">
                    <div className="col-sm-12 col-md-12 d-flex flex-column mt-10">
                      <Button
                        type={"submit"}
                        disabled={props.isLoading}
                        variant="primary btn-fill"
                      >
                        Submit Registration
                        {props.isLoading && (
                          <Spinner animation="border" role="status" size="sm">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        )}
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminUserRegistrationForm;
